(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogController', PvlogController);

    PvlogController.$inject = ['$state', 'Pvlog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PvlogController($state, Pvlog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;
        vm.getTotErrConexClass=getTotErrConexClass
        vm.getSerialReopenClass= getSerialReopenClass;
        vm.getTemperatureClass= getTemperatureClass;
        vm.getLabelClass = getLabelClass;
        vm.getLabelClassText = getLabelClassText;       
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        function getTotErrConexClass (reconn) {
            if (reconn > 0) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }

        function getSerialReopenClass (reopen) {
            if (reopen > 0) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }

        function getLabelClass (statusState) {
            if (statusState === 0) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }
             
        function getTemperatureClass (temperature) {
            if (temperature >= 60) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }
        
        function getLabelClassText (statusState) {
            if (statusState === 1) {
                return 'OK';
            } else {
                return 'ERROR';
            }
        }
        
        loadAll();

        function loadAll () {
            Pvlog.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pvlogs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
